@if (user?.avatar) {
  <div
    class="avatar"
    [ngStyle]="{ 'background-image': user?.avatar | asUrl }"
  ></div>
}
@if (!user?.avatar) {
  <div
    class="avatar"
    [ngStyle]="{ 'background-image': 'assets/imgs/logo.webp' | asUrl }"
  ></div>
}
